import styles from '../../../page.module.scss';

interface BookCardProps {
  title: string;
  authors: string[];
  image: string;
  id?: string;
}

const BookCard: React.FC<BookCardProps> = ({ title, authors, image, id }) => {
  return (
    <div className={styles.bookCard}>
      <img src={image} alt={`tapa del libro ${title}`} />
      <h3>{title}</h3>
      <p>{authors}</p>
    </div>
  );
};

export default BookCard;
